import RGBColor from '../classes/rgb-color';
import hex2decimal from './hex-to-decimal';
import verifiers from '../verifiers';
import helpers from '../helpers';

const hex2rgb = (hexColor) => {
  if (!verifiers.isHexColor(hexColor)) {
    throw Error(`Invalid hex color string: ${hexColor}`);
  }

  const hex = hexColor[0] === '#' ? hexColor.substr(1) : hexColor;
  const [hexRed, hexGreen, hexBlue, hexAlpha] = helpers.extractSpectrumFromHex(hex);

  const red = hex2decimal(hexRed) / 255;
  const green = hex2decimal(hexGreen) / 255;
  const blue = hex2decimal(hexBlue) / 255;
  const alpha = hex2decimal(hexAlpha) / 255;

  return new RGBColor(red, green, blue, alpha);
};

export default hex2rgb;
